export const IS_EN = true;
export const IS_RTL = false;
export const LANG_CODE = 'en';
export const LANG_DIR = 'ltr';
export const ALTER_LANG_NAME = 'العربيه';
export const ALTER_LANG_CODE = 'ar';
export const FOSOL = 'fosol';
export const TAG_LINE = 'The best way to communicate between students and teachers';
export const LOG_IN = 'Log In';
export const VIA = 'via';
export const PHONE = 'Mobile';
export const EMAIL = 'Email';
export const PHONE_PH = 'e.g. 555333000';
export const EMAIL_PH = 'e.g. joe@example.com';
export const USE_EMAIL = 'Use email address instead';
export const USE_PHONE = 'Use mobile number instead';
export const NEXT = 'Next';
export const VERIFICATION_SENT = 'Verification code has been sent to';
export const VERIFY = 'Verify';
export const SAVE = 'Save';
export const SEND = 'Send';
export const RESEND = 're-send';
export const CODE = 'Code';
export const NAME = 'Name';
export const FULL_NAME = 'Enter Your Full Name';
export const FULL_NAME_PH = 'e.g. John Smith';
export const BACK = 'Back';
export const OK = 'Ok';



// WEBPACK FOOTER //
// ./src/lang/en/nologin.js